import axios from 'axios'

export default {
  namespaced: true,
  state: {
    type: null,
  },
  getters: {
  },
  mutations: {
    setSport(state, type) {
      state.type = type;
    },
  },
}